// ============================================================================
// ITALIAN TRANSLATIONS - FUN QUESTIONS
// ============================================================================
// Domande riflessive e interessanti sulla fede

export const funQuestions = [
  {
    question: "Quale atto d'amore di Gesù ti ispira di più nella tua vita quotidiana?",
    emoji: "❤️",
    theme: "amore"
  },
  {
    question: "Se potessi condividere un pasto con un personaggio biblico, chi sarebbe e perché?",
    emoji: "🍞",
    theme: "incontro"
  },
  {
    question: "Quale parabola di Gesù ti parla più profondamente e perché?",
    emoji: "🌱",
    theme: "insegnamento"
  },
  {
    question: "Come si manifesta la pace di Dio nella tua vita?",
    emoji: "🕊️",
    theme: "pace"
  },
  {
    question: "Quale miracolo di Gesù ti sarebbe piaciuto vedere?",
    emoji: "✨",
    theme: "fede"
  },
  {
    question: "Se dovessi descrivere l'amore di Dio in una parola, quale sarebbe?",
    emoji: "💝",
    theme: "amore divino"
  },
  {
    question: "Quale versetto della Bibbia ti ha aiutato in un momento difficile?",
    emoji: "📖",
    theme: "conforto"
  },
  {
    question: "Come puoi essere luce del mondo oggi?",
    emoji: "💡",
    theme: "testimonianza"
  }
];

export default funQuestions;
